var SaveOrigin = function () {
    this._savedOriginX = this.x;
    this._savedOriginY = this.y;
    return this;
}
export default SaveOrigin;